/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, ButtonGroup, Grid, Typography, Tooltip, IconButton, Button, Switch, Modal } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../../Page';
import services from '../../Service';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import Paper from '@material-ui/core/Paper';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AlertDialog } from './../../../Common/AlertDialog';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { Autocomplete } from '@mui/material';
import ImageUploader from 'react-images-upload';
import CardMedia from '@material-ui/core/CardMedia';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DialogContent from '@mui/material/DialogContent';
import RotateRightIcon from '@material-ui/icons/RotateRight';

export function Bank({ handleNext, handleBack, farmerId }) {
    const [message, setMessage] = useState("Delete Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [farmerBankDetailsID, setFarmerBankDetailsID] = useState();
    const [bankList, setBankList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [dataGrid, setDataGrid] = useState([]);
    const [factoryType, setFactoryType] = useState(0);
    const [IsClearBranch, setIsClearBranch] = useState(false);
    const [open, setOpen] = useState(false);
    const [rotateImage, setRotateImage] = useState(0);
    const [isSaving, setIsSaving] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isDefault, setIsDefault] = useState(true);
    const [isDefaultConfirmMessage1, setIsDefaultConfirmMessage1] = useState(false)
    const [removeConfirmation, setRemoveConfirmation] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [isDefaultDeleteData, setIsDefaultDeleteData] = useState(false);
    const [isDefaultConfirmMessage2, setIsDefaultConfirmMessage2] = useState(false)
    const [formData, setFormData] = useState({
        bankID: '',
        branchID: '',
        branchCode: '',
        accountnumber: '',
        accountName: ''
    });
    const [formImageData, setFormImageData] = useState({
        fileName: '',
        fileExtension: '',
        image: ''
    });
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        Edit: false,
        submitButtonName: "Add",
        pageheadername: "Add Bank Details "
    });
    const [ImageObject, setImageObject] = useState(null);

    const BankSaveSchema = Yup.object().shape({
        bankID: Yup.number().required('Bank required'),
        branchID: Yup.number().required('Branch required'),
        branchCode: Yup.string().required('Branch Code required'),
        accountnumber: Yup.string().required('Account Number required').matches(/^[0-9\b]+$/, 'Only allow numbers'),
        accountName: Yup.string().required('Account Name required').matches(/^[a-zA-Z0-9]+(?:\s[a-zA-Z0-9]+)*$/, 'Only alphabet letters allowed.')
    });
    const formik = useFormik({
        initialValues: {
            bankID: formData.bankID,
            branchID: formData.branchID,
            branchCode: formData.branchCode,
            accountnumber: formData.accountnumber,
            accountName: formData.accountName,
            image: formImageData.image
        },
        validationSchema: BankSaveSchema,
        onSubmit: (values) => {
            if (values.image !== '') {
                setIsSaving(true);
                addGrid(values)
            }
            else {
                toast.error("Please Add a Bank Passbook Image");
            }
        },
        enableReinitialize: true

    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(getBankForDropdown());
        trackPromise(getBankDetailsbyFarmerID(farmerId));
    }, []);
    useEffect(() => {
        if (pageProps.Edit != true) {
            setIsClearBranch(!IsClearBranch);
            if (formik.values.branchID == '') {
                setValues({
                    ...values,
                    branchCode: ''
                })
            }
        }
    }, [formik.values.bankID]);

    useEffect(() => {
        trackPromise(getBranchCodebyBranchID());
    }, [formik.values.branchID]);

    useEffect(() => {
        setValues
    }, [pageProps.submitButtonName]);

    useEffect(() => {
        trackPromise(getBranchForDropdown());
    }, [formik.values.bankID]);

    useEffect(() => {
        if (!isEdit) {
            if (dataGrid.length == 0) {
                setIsDefault(true)
            } else {
                setIsDefault(false)
            }
        }
    }, [dataGrid]);

    function generateBankDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.bankID} value={x.bankID}>{x.bankName}</MenuItem>)
            });
        }
        return items
    }

    function generateBranchDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.branchID} value={x.branchID}>{x.branchName}</MenuItem>)
            });
        }
        return items
    }

    async function getBankForDropdown() {
        const bank = await services.GetBanksForDropdown();
        setBankList(bank);
        setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))
    }

    async function getBranchForDropdown() {
        const branch = await services.GetBranchForDropdown(formik.values.bankID);
        setBranchList(branch);
        if (branch.length === 0) {
            setValues({
                ...values,
                branchCode: ''
            })
        }
    }

    //----------------------------------------------------------

    function handleSearchBranch(data, e) {
        if (data === undefined || data === null) {
            setValues({
                ...values,
                branchID: '0',
                branchCode: ''
            });
            return;
        } else {
            var valueV = data["branchID"];
            var valueV2 = data["branchName"];
            const filtered = branchList.filter(obj => obj.branchID === parseInt(valueV));

            setValues({
                ...values,
                branchID: parseInt(valueV),
                branchCode: filtered == undefined ? "" : filtered[0].branchCode
            });
        }
    }

    //----------------------------------------------------------

    async function addGrid(values) {
        if (pageProps.Edit != true) {
            var result = dataGrid.find(x => x.accountNumber == values.accountnumber && x.bankID == values.bankID);
            if (result == undefined) {
                const res = await services.SaveFarmerBankDetails(values, farmerId, isDefault);
                if (res > 0) {
                    toast.success("Bank Details Saved Succesfully");
                    trackPromise(getBankDetailsbyFarmerID(farmerId));
                    setIsSaving(false);
                    setIsDefault(false);
                    clearAll();
                }
                else if(res == -2){
                    toast.error("Add at least one default account");
                    setIsSaving(false);
                    setIsDefault(false);
                } else {
                    toast.error("Try Again.Error Saving Bank Accout");
                    setIsSaving(false);
                    setIsDefault(false);
                }
            }
            else {
                toast.error("Account Number Already Exist");
                setIsSaving(false);
            }
        }
        else {
            setIsEdit(false);
            var formData = {
                farmerBankDetailsID: parseInt(pageProps.editingID),
                bankID: parseInt(values.bankID),
                farmerID: parseInt(farmerId),
                accountnumber: values.accountnumber,
                accountName: values.accountName,
                branchID: parseInt(values.branchID),
                branchCode: values.branchCode,
                image: values.image,
                isDefault: isDefault,
                modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
            };
            const res = await services.UpdateFarmerBankDetails(formData);
            if (res.statusCode == 'Success') {
                toast.success(res.message);
                trackPromise(getBankDetailsbyFarmerID(farmerId));
                setIsSaving(false);
                setIsDefault(false);
                setPageProps({
                    ...pageProps,
                    editingID: 0,
                    Edit: false,
                    submitButtonName: "Add",
                })
                clearAll();
            } else {
                toast.error(res.message);
                setIsSaving(false);
                setIsDefault(false);
            }
        }
    }

    async function getBankDetailsbyFarmerID(farmerId) {
        const res = await services.GetBankDetailsbyFarmerID(farmerId);
        setDataGrid(res)
    }

    async function getBranchCodebyBranchID() {
        const filtered = branchList.filter(obj => obj.branchID === parseInt(formik.values.branchID));
        setValues({
            ...values,
            branchCode: filtered == undefined ? "" : filtered[0].branchCode
        })
    }

    async function DeleteItem(data) {
        const res = await services.DeleteFarmerBankDetails(data);
        if (isDefaultDeleteData) {
            const updateData = dataGrid.find(x => x.farmerBankDetailsID !== data && x.isDefault == false);
            var formData = {
                farmerBankDetailsID: parseInt(updateData.farmerBankDetailsID),
                bankID: parseInt(updateData.bankID),
                farmerID: parseInt(farmerId),
                accountnumber: updateData.accountNumber,
                accountName: updateData.accountName,
                branchID: parseInt(updateData.branchID),
                branchCode: updateData.branchCode,
                image: updateData.image,
                isDefault: true,
                modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
            };
            setIsDefaultDeleteData(false)
            const resup = await services.UpdateFarmerBankDetails(formData);
            if (res > 0 && resup.statusCode == 'Success') {
                toast.success("Bank Details Deleted Succesfully");
                trackPromise(getBankDetailsbyFarmerID(farmerId));
                clearAll();
            } else {
                toast.error(res.message);
            }
        } else {
            if (res > 0) {
                toast.success("Bank Details Deleted Succesfully");
                trackPromise(getBankDetailsbyFarmerID(farmerId));
                clearAll();
            } else {
                toast.error(res.message);
            }
        }
    }

    async function clearAll() {
        setImageObject(null)
        formik.resetForm();
        setIsClearBranch(!IsClearBranch);
    }

    function confirmData(y) {
        if (y) {
            DeleteItem(farmerBankDetailsID);
        }
    }

    function confirmIsDefault1(y) {
        if (y) {
            setIsDefault(false)
        }
        else {
            setIsDefault(true)
        }
    }
    function confirmIsDefault2(y) {
        if (y) {
            setIsDefault(true)
        }
        else {
            setIsDefault(false)
        }
    }

    function handleConfirm(data) {
        const deleteData = dataGrid.find(x => x.farmerBankDetailsID == data);
        setIsDefaultDeleteData(deleteData.isDefault);
        if (dataGrid.length <= 1) {
            toast.error("Add Another Bank Detail Before you remove this record");
        } else {
            setFarmerBankDetailsID(data);
            setEnableConfirmMessage(true);
        }
    }

    async function removeImage() {
        setRemoveConfirmation(true)
    };

    const handleClose = () => {
        setOpen(false);
        
    };

    const handleClose1 = () => {
        setRemoveConfirmation(false);
    };

    const handleOpen = () => {
        setRemoveConfirmation(false);
        setImageObject(null);
        setValues({
            ...values,
            image: ""
        });
        setOpen(false);
    };

    const handleRadioChange = () => {
        if (isDefault == true) {
            setIsDefaultConfirmMessage1(true)
        }
        else {
            setIsDefaultConfirmMessage2(true)
        }
    };

    function onDrop(picture, imageUrl) {
        if (imageUrl.length == 0) {
            toast.error("Image not supported");
            return;
        }
        else {
            var convertedString = imageUrl[0];
            var fields = convertedString.split(",");
            var fields2 = fields[0].split(";");
            var fields3 = fields2[1].split("=");
            var fields4 = fields3[1].split(".");

            setImageObject(fields[1]);
            setValues({
                ...values,
                image: fields[1]
            });
        }
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value

        const filtered = branchList.filter(obj => obj.branchID === parseInt(value));
        setValues({
            ...values,
            branchID: value,
            branchCode: filtered == undefined ? "" : filtered[0].branchCode
        });
    }

    function handleEdit(rowData, index) {
        setIsEdit(true);
        var array = [...dataGrid];
        setValues({
            ...values,
            bankID: rowData.bankID,
            branchID: rowData.branchID,
            branchCode: rowData.branchCode,
            accountnumber: rowData.accountNumber,
            accountName: rowData.accountName,
            image: rowData.image
        })
        setIsDefault(rowData.isDefault)
        setImageObject(rowData.image)
        array.splice(index, 1);
        setPageProps({
            ...pageProps,
            editingID: rowData.farmerBankDetailsID,
            Edit: true,
            submitButtonName: "Update",
        })
        setDataGrid(array);
    }

    const handleImageClick = () => {
        setOpen(true);
        setRemoveConfirmation(false);
    };

    const handleRemoveClick = () => {
        setRemoveConfirmation(true);
    };

    const handleImageClick1 = (imageURL) => {
        setSelectedImage(imageURL);
    };

    const handleCloseModal = () => {
        setSelectedImage(null);
    };

    function rotateDialog() {
        setRotateImage(rotateImage + 90)
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Bank Details  |  FAPS">
                <Container>
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate onSubmit={handleSubmit}
                        >
                            <Card style={{ justifycontent: 'center' }} >
                                <Stack spacing={2} margin={3}>
                                    <Typography variant="h6">{(factoryType == 1 || factoryType == 3) ? "View Bank Details" : "Bank Details"}
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" >
                                            <ButtonGroup disableElevation variant="outlined" color="primary">
                                                <Tooltip title="Sarubima">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleBack}
                                                    >
                                                        <ArrowBackIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Loan">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleNext}
                                                    >
                                                        <ArrowForwardIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </Stack>
                                    </Typography>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Bank Name *"
                                            name="BankID"
                                            value={formik.values.bankID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('bankID')}
                                            error={Boolean(touched.bankID && errors.bankID)}
                                            helperText={touched.bankID && errors.bankID}
                                            disabled={factoryType == 1 || factoryType == 3}
                                            InputProps={{
                                                readOnly: pageProps.isEditType == 3
                                            }}
                                        >
                                            <MenuItem key="0" value="0">Select Bank Name</MenuItem>
                                            {generateBankDropDownMenu(bankList)}
                                        </TextField>
                                        {(pageProps.Edit != true) ?
                                            <Autocomplete fullWidth
                                                key={IsClearBranch}
                                                id="branchID"
                                                options={branchList}
                                                getOptionLabel={(option) => option.branchName != null ? option.branchName.toString() : null}
                                                onChange={(e, value) => handleSearchBranch(value, e)}
                                                defaultValue={null}
                                                renderInput={(params) =>
                                                    <TextField {...params}
                                                        variant="outlined"
                                                        name="branchID"
                                                        label="Branch *"
                                                        size="small"
                                                        fullWidth
                                                        value={formik.values.branchID}
                                                        getOptionDisabled={true}
                                                        disabled={factoryType == 1 || factoryType == 3}
                                                        error={Boolean(touched.branchID && errors.branchID)}
                                                        helperText={touched.branchID && errors.branchID}
                                                    />
                                                }
                                            />
                                            :
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Branch *"
                                                name="BranchID"
                                                value={formik.values.branchID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('branchID')}
                                                error={Boolean(touched.branchID && errors.branchID)}
                                                helperText={touched.branchID && errors.branchID}
                                                disabled={factoryType == 1 || factoryType == 3}
                                                InputProps={{
                                                    readOnly: pageProps.isEditType == 3
                                                }}
                                            >
                                                <MenuItem key="0" value="0">Select Branch Name</MenuItem>
                                                {generateBranchDropDownMenu(branchList)}
                                            </TextField>
                                        }
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Branch Code *"
                                            value={formik.values.branchCode}
                                            onChange={formik.handleChange}
                                            error={Boolean(touched.branchCode && errors.branchCode)}
                                            helperText={touched.branchCode && errors.branchCode}
                                            InputProps={{
                                                readOnly: true
                                            }}
                                            disabled={factoryType == 1 || factoryType == 3}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                        <Grid item xs={4} sm={4} md={4}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Account Number *"
                                                value={dataGrid.bankID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('accountnumber')}
                                                error={Boolean(touched.accountnumber && errors.accountnumber)}
                                                helperText={touched.accountnumber && errors.accountnumber}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            />
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Account Name *"
                                                value={formik.values.accountName}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('accountName')}
                                                error={Boolean(touched.accountName && errors.accountName)}
                                                helperText={touched.accountName && errors.accountName}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            />
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4}>   </Grid>
                                    </Stack>
                                    <Typography variant="h6">
                                        Bank Passbook *
                                    </Typography>
                                    <Stack spacing={2} margin={3}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Stack style={{ width: '250px' }}>
                                                <ImageUploader
                                                    //withIcon={false}
                                                    singleImage={true}
                                                    //withPreview={true}
                                                    buttonText='Upload Bank Passbook Image'
                                                    onChange={onDrop}
                                                    image={formik.values.image}
                                                    imgExtension={['.jpg', '.png']}
                                                    maxFileSize={5242880}
                                                />
                                            </Stack>
                                            {ImageObject != null ? (
                                                <div>
                                                    <div>
                                                        <Card onClick={handleImageClick} style={{ cursor: 'pointer' }}>
                                                            <CardMedia
                                                                component="img"
                                                                height="140"
                                                                image={`data:image/jpeg;base64,${ImageObject}`}
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </Card>
                                                        <Button
                                                            fullWidth
                                                            color="secondary"
                                                            type="button"
                                                            variant="contained"
                                                            onClick={handleRemoveClick}
                                                        >
                                                            Remove
                                                        </Button>

                                                        <Dialog open={open} onClose={handleClose} aria-labelledby="image-dialog-title">
                                                            <DialogContent>
                                                                <CardMedia
                                                                    component="img"
                                                                    height="400"
                                                                    image={`data:image/jpeg;base64,${ImageObject}`}
                                                                />
                                                            </DialogContent>
                                                            <DialogActions>
                                                                <Button onClick={handleClose}>Close</Button>
                                                            </DialogActions>
                                                        </Dialog>

                                                        <Dialog open={removeConfirmation} onClose={handleClose} aria-labelledby="remove-dialog-title">
                                                            <DialogTitle id="remove-dialog-title">
                                                                {"Are you sure you want to delete this image?"}
                                                            </DialogTitle>
                                                            <DialogActions>
                                                                <Button onClick={handleClose1}>No</Button>
                                                                <Button onClick={handleOpen}>Yes</Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </Stack>
                                    </Stack>
                                    <Stack spacing={2} margin={3}>
                                        <Grid item md={4} xs={12} >
                                            <FormControlLabel
                                                style={{ width: '190px' }}
                                                control={
                                                    <Switch
                                                        checked={isDefault}
                                                        onChange={handleRadioChange}
                                                    //disabled={dataGrid.length == 0} 
                                                    />}
                                                label="Is Default"
                                                labelPlacement="end"
                                            />
                                        </Grid>
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <LoadingButton
                                            size="medium"
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                            disabled={pageProps.Edit || factoryType == 1 || factoryType == 3}
                                        >
                                            Clear
                                        </LoadingButton>
                                        <LoadingButton
                                            size="medium"
                                            type="submit"
                                            variant="outlined"
                                            color='secondary'
                                            disabled={factoryType == 1 || factoryType == 3 || isSaving == true}
                                        >
                                            {pageProps.submitButtonName}
                                        </LoadingButton>
                                    </Stack>
                                    <Divider variant="middle" />
                                    {(dataGrid.length > 0) ?
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '65rem' }} >
                                                <TableContainer component={Paper} >
                                                    <Table aria-label="caption table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="left">Bank</TableCell>
                                                                <TableCell align="left">Branch</TableCell>
                                                                <TableCell align="left">Branch Code</TableCell>
                                                                <TableCell align="left">Account Number</TableCell>
                                                                <TableCell align="left">Account Name</TableCell>
                                                                <TableCell align="left">Is Default</TableCell>
                                                                <TableCell align="center">Passbook</TableCell>
                                                                {(factoryType == 1 || factoryType == 3) ? null :
                                                                    <TableCell align="center">Actions</TableCell>}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {dataGrid.map((rowData, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell align="left" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.bankName}
                                                                    </TableCell>
                                                                    <TableCell align="left" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.branchName}
                                                                    </TableCell>
                                                                    <TableCell align="left" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.branchCode}
                                                                    </TableCell>
                                                                    <TableCell align="left" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.accountNumber}
                                                                    </TableCell>
                                                                    <TableCell align="left" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.accountName}
                                                                    </TableCell>
                                                                    <TableCell align="left" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.isDefault == null || rowData.isDefault == false ? 'False' : 'True'}
                                                                    </TableCell>
                                                                    <TableCell align="right" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        <img src={`data:image/jpeg;base64,${rowData.image}`} onClick={() => handleImageClick1(`data:image/jpeg;base64,${rowData.image}`)} alt={`Image ${index}`} style={{ width: '75px', height: 'auto', display: 'block', margin: '0 auto' }} />
                                                                    </TableCell>
                                                                    {(factoryType == 1 || factoryType == 3) ? null :
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {pageProps.Edit != true ? (
                                                                                <Tooltip title="Edit">
                                                                                    <IconButton
                                                                                        variant="outlined"
                                                                                        onClick={() => handleEdit(rowData, index)}
                                                                                    >
                                                                                        <EditIcon />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            ) : null}
                                                                            <Tooltip title="Delete">
                                                                                <IconButton
                                                                                    variant="outlined"
                                                                                    color="error"
                                                                                    disabled={isEdit}
                                                                                    onClick={(e) => handleConfirm(rowData.farmerBankDetailsID)}>
                                                                                    <DeleteIcon />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </TableCell>}
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Card>
                                        </Stack> : null}
                                </Stack>
                            </Card>
                        </Form>
                    </FormikProvider>
                </Container>
                {/* <Modal open={selectedImage !== null} onClose={handleCloseModal}>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', transform: `rotate(${180}deg)` }}>
                            <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }} onClick={handleCloseModal}></div>
                            {selectedImage && <img src={selectedImage} alt="Larger Biometric Data" style={{ maxWidth: '90%', maxHeight: '90%', zIndex: 2 }} />}
                        </div>
                        <Tooltip title="Rotate" >
                            <IconButton style={{ width: 40, background: "white" }} aria-label="delete"
                                onClick={rotateDialog}
                            >
                                <RotateRightIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                </Modal> */}
                <Dialog open={selectedImage !== null} onClose={handleCloseModal} style={{ background: "transparent" }}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                            overflowX: "hidden",
                            overflowY: "hidden"
                        },
                    }}>
                    <CardMedia style={{ transform: `rotate(${rotateImage}deg)` }} height="400" component="img" image={selectedImage} />
                    &nbsp;&nbsp;
                    <Tooltip title="Rotate" >
                        <IconButton style={{ width: 40, background: "white" }} aria-label="delete"
                            onClick={rotateDialog}
                        >
                            <RotateRightIcon />
                        </IconButton>
                    </Tooltip>
                </Dialog>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={isDefaultDeleteData ? "This account is set as the default. Are you sure you want to delete it? Deleting this account will automatically set another account as the default. Please confirm your action." : "Are you sure want to delete bank details ?"}
                            setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmIsDefault1} headerMessage={"Is Default Confirmation"} viewPopup={isDefaultConfirmMessage1}
                            discription={"Are you sure want to change Default Bank Account ?"} setViewPopup={setIsDefaultConfirmMessage1} />
                    </Grid>
                    <Grid item>
                        <AlertDialog confirmData={confirmIsDefault2} headerMessage={"Is Default Confirmation"} viewPopup={isDefaultConfirmMessage2}
                            discription={"Are you sure want to change Default Bank Account ?"} setViewPopup={setIsDefaultConfirmMessage2} />
                    </Grid>
                </div>
            </Page>
        </>
    )
}